import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { adminApiHeader, finalRouteApi } from '../../components/CommonApis/CommonApiUrl';
import AdminBackNavigation from '../../components/CommonComponents/AdminBackNavigation';

export default function AssignFields() {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [fields, setFields] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [form, setForm] = useState({ custom_field_id:'', page_identifier:'', roles:'', plans:'', order:0, active:true });

  useEffect(() => {
    let mounted = true;
    async function init() {
      try {
        const feat = await axios.get(`${finalRouteApi}/admin/features/custom-fields`, { headers: adminApiHeader });
        if (!mounted) return;
        if (!feat.data?.enabled) { setEnabled(false); setLoading(false); return; }
        setEnabled(true);
        const [f, a] = await Promise.all([
          axios.get(`${finalRouteApi}/custom-fields`, { headers: adminApiHeader }),
          axios.get(`${finalRouteApi}/custom-fields-assign`, { headers: adminApiHeader })
        ]);
        if (!mounted) return;
        setFields(f.data?.fields || []);
        setAssignments(a.data?.assignments || []);
      } catch (e) { setError(e?.response?.data?.message || e.message); }
      finally { setLoading(false); }
    }
    init();
    return () => { mounted = false; };
  }, []);

  const canSubmit = useMemo(() => form.custom_field_id && form.page_identifier.trim(), [form]);

  const submit = async () => {
    setError('');
    try {
      const payload = {
        ...form,
        roles: form.roles ? form.roles.split(',').map(x => parseInt(x.trim())).filter(Boolean) : [],
        plans: form.plans ? form.plans.split(',').map(x => parseInt(x.trim())).filter(Boolean) : [],
      };
      await axios.post(`${finalRouteApi}/custom-fields-assign`, payload, { headers: adminApiHeader });
      const a = await axios.get(`${finalRouteApi}/custom-fields-assign`, { headers: adminApiHeader });
      setAssignments(a.data?.assignments || []);
    } catch (e) { setError(e?.response?.data?.message || e.message); }
  };

  const remove = async (id) => {
    try {
      await axios.delete(`${finalRouteApi}/custom-fields-assign/${id}`, { headers: adminApiHeader });
      setAssignments(assignments.filter(x => x.id !== id));
    } catch (e) { setError(e?.response?.data?.message || e.message); }
  };

  if (loading) return <div>Loading…</div>;
  if (!enabled) return <div>Custom Fields addon is disabled.</div>;

  return (
    <div>
      <AdminBackNavigation path="/custom-fields" text="Back to Custom Fields" />
      <h2>Assign Fields to Pages</h2>
      {error && <div style={{color:'red'}}>{error}</div>}
      <div className="card p-2 mb-3">
        <div className="mb-2">
          <label>Field</label>
          <select className="form-control" value={form.custom_field_id} onChange={e => setForm(f => ({...f, custom_field_id: e.target.value}))}>
            <option value=''>-- select --</option>
            {(fields||[]).map(f => <option key={f.id} value={f.id}>{f.name} ({f.key})</option>)}
          </select>
        </div>
        <div className="mb-2">
          <label>Page Identifier</label>
          <input className="form-control" placeholder="e.g., videos.edit" value={form.page_identifier} onChange={e => setForm(f => ({...f, page_identifier: e.target.value}))} />
        </div>
        <div className="mb-2">
          <label>Roles (comma separated IDs)</label>
          <input className="form-control" value={form.roles} onChange={e => setForm(f => ({...f, roles: e.target.value}))} />
        </div>
        <div className="mb-2">
          <label>Plans (comma separated IDs)</label>
          <input className="form-control" value={form.plans} onChange={e => setForm(f => ({...f, plans: e.target.value}))} />
        </div>
        <div className="mb-2">
          <label>Order</label>
          <input type="number" className="form-control" value={form.order} onChange={e => setForm(f => ({...f, order: parseInt(e.target.value||0)}))} />
        </div>
        <div className="mb-2">
          <label><input type="checkbox" checked={form.active} onChange={e => setForm(f => ({...f, active: e.target.checked}))} /> Active</label>
        </div>
        <button className="btn btn-primary" disabled={!canSubmit} onClick={submit}>Assign</button>
      </div>

      <table className="table">
        <thead><tr><th>Page</th><th>Field</th><th>Roles</th><th>Plans</th><th>Order</th><th>Actions</th></tr></thead>
        <tbody>
          {(assignments||[]).map(a => (
            <tr key={a.id}>
              <td>{a.page_identifier}</td>
              <td>{a.field?.name} ({a.field?.key})</td>
              <td>{Array.isArray(a.roles) ? a.roles.join(',') : ''}</td>
              <td>{Array.isArray(a.plans) ? a.plans.join(',') : ''}</td>
              <td>{a.order}</td>
              <td><button className="btn btn-sm btn-danger" onClick={() => remove(a.id)}>Delete</button></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
